<template>
    <!-- The same component instance is reused when only the collectionID
         changes: the key forces a new iframe URL for the new collection. -->
    <AdminNextIframe
        :key="$route.params.collectionID"
        :path="`/collections/${$route.params.collectionID}`"
        :query="{ clientId: $route.params.id }"
        allow="clipboard-write"
        @navigate="onNavigate"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientCollectionsDetailsIframe',
    components: { AdminNextIframe },
    methods: {
        // next-admin posts `navigate` on every one of its own route changes:
        // ignore the routes that live inside the iframe (create, selector, and
        // this very collection) and only re-route on a different collection id.
        onNavigate(path) {
            const detail = path.match(/^\/collections\/([^/]+)\/?$/);
            if (!detail) return;

            const segment = detail[1];
            if (segment === 'new' || segment === 'select-articles') return;
            if (segment === this.$route.params.collectionID) return;

            this.$router.push({
                name: 'client-collections-details',
                params: { id: this.$route.params.id, collectionID: segment }
            }).catch(() => {});
        },
        onBack() {
            this.$router.push({
                name: 'client-collections',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
